import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BillingType, BillingTypes } from '../../billing-type';
import { IPackageType, PackageTypes } from '../../package-type';
import { AppTextService } from '@fi-shared/app-text';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { CentralBillingUnitModuleModel } from '../central-billing-unit-module.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiToggleSwitchLabelAlign } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-billing-central-edit',
    templateUrl: './billing-central-edit.component.html',
    styleUrls: ['./billing-central-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-central-edit' },
    standalone: false,
})
export class BillingCentralEditComponent implements OnInit {
    @Input() businessUnitModule: CentralBillingUnitModuleModel;

    BillingTypes: { Id: BillingType; TextId: string }[] = BillingTypes;
    packageTypeListData = new DropdownSettingsModelV2<INameIdObj>({
        orderBy: 'Id',
    });
    editTabs: EditTabsModel;
    FiToggleSwitchLabelAlign = FiToggleSwitchLabelAlign;

    constructor(
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
    ) {}

    ngOnInit() {
        this.saveChangesWarningService.start(() => this.businessUnitModule);
        this.setPackageTypeListData();
        this.setPageHeaderData();
    }

    private setPackageTypeListData() {
        const packageTypeNames = PackageTypes.map((item: IPackageType) => {
            return { Id: item.Id, Name: this.appTextService.get(item.TextId) };
        });
        this.packageTypeListData.setDataSet(packageTypeNames);
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(this.objectTitleService.getEditTitle(this.businessUnitModule.ModuleTypeName));
        this.editTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    save() {
        this.fiLoadingService
            .trackPromise(this.billingService.SaveCentralBillingModule(this.businessUnitModule))
            .then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.Billing.Central.List);
            });
    }
}
